import { whitelabelConfig } from '@/brands';

const capName = (whitelabelConfig.capitalizer.displayName ?? '')
  .replace(/[̀-ͯ]/g, '')
  .toLowerCase();

const isLotep = capName.includes('lotep');

export const ticketLabels = isLotep
  ? {
      singular: 'bilhete',
      plural: 'bilhetes',
      singularCaps: 'Bilhete',
      pluralCaps: 'Bilhetes',
      myTickets: 'Meus Bilhetes',
    }
  : {
      singular: 'título',
      plural: 'títulos',
      singularCaps: 'Título',
      pluralCaps: 'Títulos',
      myTickets: 'Meus Títulos',
    };
